// extracted by mini-css-extract-plugin
export var searchHeader = "_ae-0";
export var searchHeaderDark = "_ae-1";